export const quotesConstants = {
  GET_QUOTES_REQUEST: 'GET_QUOTES_REQUEST',
  GET_QUOTES_SUCCESS: 'GET_QUOTES_SUCCESS',
  GET_QUOTES_FAILURE: 'GET_QUOTES_FAILURE',
  GET_DASHBOARD_REQUEST: 'GET_DASHBOARD_REQUEST',
  GET_DASHBOARD_SUCCESS: 'GET_DASHBOARD_SUCCESS',
  GET_DASHBOARD_FAILURE: 'GET_DASHBOARD_FAILURE',
  UPDATE_QUOTES_COMMENTS: 'UPDATE_QUOTES_COMMENTS',
};
